import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientService } from '../../../core/http';
import type {
  CreateProductRequest,
  ProductDto,
  ProductListResponse,
  UpdateProductRequest
} from '../models/product.model';

@Injectable({ providedIn: 'root' })
export class ProductsApiService {
  private readonly api = inject(ApiClientService);

  list(params?: { page?: number; pageSize?: number; q?: string }): Observable<ProductListResponse> {
    return this.api.get<ProductListResponse>('/products', params);
  }

  getById(id: string): Observable<{ data: ProductDto }> {
    return this.api.get<{ data: ProductDto }>(`/products/${id}`);
  }

  create(body: CreateProductRequest): Observable<{ data: ProductDto }> {
    return this.api.post<{ data: ProductDto }>('/products', body);
  }

  update(id: string, body: UpdateProductRequest): Observable<{ data: ProductDto }> {
    return this.api.patch<{ data: ProductDto }>(`/products/${id}`, body);
  }

  toggleStatus(id: string, isActive?: boolean): Observable<{ data: ProductDto }> {
    return this.api.patch<{ data: ProductDto }>(`/products/${id}/toggle-status`, isActive === undefined ? {} : { isActive });
  }

  delete(id: string): Observable<{ data: { deleted: true } }> {
    return this.api.delete<{ data: { deleted: true } }>(`/products/${id}`);
  }
}
